import { Component, Input, OnInit, ElementRef, ViewChild, OnChanges, inject, TemplateRef } from "@angular/core";
import { Slide } from "./mosaic.inferface";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mosaic',
  templateUrl: './mosaic.component.html',
  styleUrls: ['./mosaic.component.scss']
})
export class MosaicComponent implements OnInit, OnChanges {
  private modalService = inject(NgbModal);
  @Input() slides: Slide[];
  currentSlide: number = 0;
  totalShow: number = 3;

  @ViewChild('gridLayout') container: ElementRef;

  constructor() { }

  ngOnInit(): void { }

  ngOnChanges() {
    this.currentSlide = 0;
    window.setTimeout(() => {
      if (this.container.nativeElement.offsetWidth < 625) {
        this.totalShow = 6;
      }
    }, 100);
  }

  open(content: TemplateRef<any>, rowIndex: number) {
    this.currentSlide = rowIndex;
    this.modalService.open(content, { ariaLabelledBy: 'Property Images', size: 'xl' });
  }

  prev() {
    if (this.currentSlide > 0) {
      this.currentSlide = this.currentSlide - 1;
    }
  }

  next() {
    if (this.currentSlide < this.slides.length - 1) {
      this.currentSlide = this.currentSlide + 1;
    }
  }
}
